/**
 * The head of the page for lawyers — ONE component, rendered by today's page (src/pages/ForLawyers.tsx) and by its
 * rebuild in the new design, so the two can never tell a crawler different things (PV4, design record §7b). The words
 * are src/config/forLawyersSeo.ts.
 *
 * The block is the one the page has always written (react-helmet-async directly, not SeoHead): changing it to
 * SeoHead would add a second card and structured data to prest0.ai's search listing, which a rebuild never does.
 * `noIndex` asks to stay out of search. The demonstration address already carries its one noindex, so there this
 * writes none (headWritesNoindex in src/design/previewPath.ts).
 */
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { FOR_LAWYERS_SEO } from '../config/forLawyersSeo';
import { headWritesNoindex } from '../design/previewPath';

export const ForLawyersHead: React.FC<{ noIndex?: boolean }> = ({ noIndex = false }) => (
  <Helmet>
    <title>{FOR_LAWYERS_SEO.title}</title>
    <meta name="description" content={FOR_LAWYERS_SEO.description} />
    <meta name="keywords" content={FOR_LAWYERS_SEO.keywords} />
    <link rel="canonical" href={FOR_LAWYERS_SEO.canonicalUrl} />
    <meta property="og:title" content={FOR_LAWYERS_SEO.ogTitle} />
    <meta property="og:description" content={FOR_LAWYERS_SEO.ogDescription} />
    <meta property="og:url" content={FOR_LAWYERS_SEO.canonicalUrl} />
    {headWritesNoindex(noIndex) && <meta name="robots" content="noindex, nofollow" />}
  </Helmet>
);

export default ForLawyersHead;
